import PaymentLogs from './PaymentLogs'

export default PaymentLogs